




import { defineComponent } from '@vue/composition-api'

/**
 * 共通 モーダルタイトル テンプレート
 */
export default defineComponent({
  name: 'ModalTitleParts',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
})
